module.exports = __webpack_public_path__ + "assets/img/fission-header.png";